import { querySet } from "./url"
import { MARKET_SDK_CHANNEL, EXTERNAL_MARKET_PAGE, EXTERNAL_W2A_PAGE, MEDIA_EVENT_REGISTER, MEDIA_EVENT_REGISTER_DFC } from "@/constants/common";

/**
 * 是否为小渠道场景
 * @returns boolean
 */
export const isEc = () => {
    if(isMarket()){
        return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.ec
    }else{
        return false
    }
}

/**
 * 是否为mgm场景
 * @returns boolean
 */
export const isMgm = () => {
  return querySet.is_mgm === '1'
}

/**
 * 是否为默认 WhatsApp 场景
 * @returns boolean
 */
export const isDefaultWa = () => {
  return querySet.is_default_wa === '1'
}

/**
 * 是否为外投场景
 * @returns boolean
 */
export const isMarket = () => {
  if (isMgm() || isOfficalWeb() || isDefaultWa()) {
    return false
  }
  if (window.adv) {
    const { isAdvChannel } = window.adv
    return isAdvChannel && isAdvChannel()
  }
  return false
}

/**
 * 是否为官网场景
 * @returns boolean
 */
export const isOfficalWeb = () => {
  return querySet.is_offical_website === '1'
}

/**
 * 是否为Facebook
 * @returns boolean
 */
export const isFacebook = () => {
    if(isMarket()){
       return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.meta
    }else{
       return false
    }
 
}

/**
 * 是否为Google
 * @returns boolean
 */
export const isGoogle = () => {
  if(isMarket()){
    return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.google
 }else{
    return false
 }
}

/**
 * 是否为Tiktok
 * @returns boolean
 */
export const isTiktok = () => {
  if(isMarket()){
    return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.tiktok
 }else{
    return false
 }
}
// 判断是否为营销打开
export const isFromMarKeTing = () => {
  const { fromPage} = querySet
  return  fromPage === EXTERNAL_MARKET_PAGE || fromPage === EXTERNAL_W2A_PAGE
}

/**
 * 是否为 WhatsApp 渠道
 * @returns boolean
 */
export const isWhatsAppChannel = () => {
  if (isMarket()) {
    const channel = window?.adv?.getChannelEnv()
    return ['meta_wa', 'google_wa', 'ops_wa'].includes(channel)
  }
  return false
}

/**
 * 是否为 didifinance.com 外投渠道
 * @returns boolean
 */
export const isDfcChannel = () => {
  return querySet.is_dfc === '1'
}

/**
 * 是否来自 didifinance.com 官网
 * 包含官网外投（is_dfc=1）和非外投官网（is_offical_website=1）
 * @returns boolean
 */
export const isDfcWebsiteSource = () => {
  return isDfcChannel() || isOfficalWeb()
}

/**
 * 解析注册/登录媒体回传事件 ID
 * didifinance.com 外投渠道回传 5004，其余外投渠道回传 5002
 * @returns number
 */
export const getRegisterMediaEventId = () => {
  return isDfcChannel() ? MEDIA_EVENT_REGISTER_DFC : MEDIA_EVENT_REGISTER
}
